export interface DeliveryZone {

  
    id: string,
    companyId: number,
    color: string,
    name: string,
    order: number,
    useDefaultSettings: boolean,
    useRouteColors: boolean,
    settingsForcedeparturetime: boolean,
    settingsIgnorecapacitylimit: boolean,
    settingsUseallvehicles: boolean,
    settingsUseSkills: boolean,
    settingsOptimizefromindex: number,
    settingsExplorationlevel: number,
    settingsDeliveryScheduleStart: number,
    settingsDeliveryScheduleEnd: number,
    settingsOptimizationParametersNumvehicles: number,
    settingsOptimizationParametersTraveldistance: number,
    settingsOptimizationParametersCustomersatisfaction: number,
    settingsOptimizationParametersVehicletimebalance: number,
    settings1Active: boolean,
    settings1Increaseproportion: number,
    settings1TimeIntervalStart: number,
    settings1TimeIntervalEnd: number,
    settings2Active: boolean,
    settings2Increaseproportion: number,
    settings2TimeIntervalStart: number,
    settings2TimeIntervalEnd: number,
    settings3Active: boolean,
    settings3Increaseproportion: number,
    settings3TimeIntervalStart: number,
    settings3TimeIntervalEnd: number,
    settingsOptimizationParametersMaxDelayTime: number,
    settingsOptimizationParametersCostDistance: number,
    settingsOptimizationParametersCostDuration: number,
    settingsOptimizationParametersCostVehicleWaitTime: number,
    showInWeb: boolean,
    company: {
        id: number,
        name: string,
        nif: string,
        vehicles: number,
        countryCode: string,
        streetAddress: string,
        city: string ,
        province: string,
        zipCode: number,
        billingEmail: string,
        serviceTypeId:number 
    },
    deliveryZoneSpecificationType?:any[],
    associatedPath?: number;
}

export class DeliveryZone implements DeliveryZone {
   
    constructor() {
       
        this.id = '',
        this.companyId = 0,
        this.color = '',
        this.name = '',
        this.order = 0,
        this.useDefaultSettings = false,
        this.useRouteColors = false,
        this.settingsForcedeparturetime = false,
        this.settingsIgnorecapacitylimit = false,
        this.settingsUseallvehicles = false,
        this.settingsUseSkills =  false,
        this.settingsOptimizefromindex = 0,
        this.settingsExplorationlevel = 0,
        this.settingsDeliveryScheduleStart = 0,
        this.settingsDeliveryScheduleEnd = 0,
        this.settingsOptimizationParametersNumvehicles = 0,
        this.settingsOptimizationParametersTraveldistance = 0,
        this.settingsOptimizationParametersCustomersatisfaction = 0,
        this.settingsOptimizationParametersVehicletimebalance = 0,
        this.settings1Active = false,
        this.settings1Increaseproportion = 0,
        this.settings1TimeIntervalStart = 0,
        this.settings1TimeIntervalEnd = 0,
        this.settings2Active = false,
        this.settings2Increaseproportion = 0,
        this.settings2TimeIntervalStart = 0,
        this.settings2TimeIntervalEnd = 0,
        this.settings3Active = false,
        this.settings3Increaseproportion = 0,
        this.settings3TimeIntervalStart = 0,
        this.settings3TimeIntervalEnd = 0,
        this.settingsOptimizationParametersMaxDelayTime = 0,
        this.settingsOptimizationParametersCostDistance = 0,
        this.settingsOptimizationParametersCostDuration = 0,
        this.settingsOptimizationParametersCostVehicleWaitTime = 0,
        this.showInWeb = false,
        this.deliveryZoneSpecificationType = [],
        this.company = {
            id: 0,
            name: '',
            nif: '',
            vehicles: 0,
            countryCode: '',
            streetAddress: '',
            city: '' ,
            province: '',
            zipCode: 0,
            billingEmail: '',
            serviceTypeId: 0 
        },
        this.associatedPath = 0;
 
    }
}
